import { NgModule } from '@angular/core';

import {SharedModule} from "../../shared/shared.module";
import {AlarmeApiService} from "./shared/alarme-api.service";
import {AlarmeNavigationService} from "./shared/alarme-navigation.service";
import {Alarmeservice} from "./shared/alarme.service";
import {AlarmeFormComponent} from "./alarme-form/alarme-form.component";
import {AlarmeListComponent} from "./alarme-list/alarme-list.component";
import {AlarmeRoutingModule} from "./alarmes-routing.module";
import {AlarmesComponent} from "./alarmes.component";

@NgModule({
    imports: [
        SharedModule,
        AlarmeRoutingModule
    ],
    providers: [
        AlarmeApiService,
        AlarmeNavigationService,
        Alarmeservice
    ],
    declarations: [
        AlarmesComponent,
        AlarmeFormComponent,
        AlarmeListComponent
    ],
    exports: [
        AlarmeListComponent
    ]
})
export class AlarmeModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/alarmes/alarmes.module.ts
 **/